import { render, staticRenderFns } from "./CaseDocPrint.vue?vue&type=template&id=5ac397bc&scoped=true&lang=pug&"
import script from "./CaseDocPrint.vue?vue&type=script&lang=js&"
export * from "./CaseDocPrint.vue?vue&type=script&lang=js&"
import style0 from "./CaseDocPrint.vue?vue&type=style&index=0&id=5ac397bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac397bc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
